import { render, staticRenderFns } from "./VRfictitious.vue?vue&type=template&id=99c2b0e2&scoped=true"
import script from "./VRfictitious.vue?vue&type=script&lang=js"
export * from "./VRfictitious.vue?vue&type=script&lang=js"
import style0 from "./VRfictitious.vue?vue&type=style&index=0&id=99c2b0e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c2b0e2",
  null
  
)

export default component.exports